<div class="dialog-content">
  <mat-dialog-content (scroll)="onScroll($event)" #dialogContent>
    <div class="dialog-header">
      <button
        mat-icon-button
        (click)="onCancel()"
        aria-label="Close dialog"
      ><svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_387_10"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="4"
              y="4"
              width="12"
              height="12"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.58539 10.0007L4.3428 14.2432L5.75702 15.6575L9.9996 11.4149L14.2423 15.6575L15.6565 14.2433L11.4138 10.0007L15.6565 5.75796L14.2423 4.34375L9.9996 8.58645L5.75699 4.34383L4.34277 5.75804L8.58539 10.0007Z"
                fill="#282B3E"
              />
            </mask>
            <g mask="url(#mask0_387_10)">
              <rect width="20" height="20" fill="#282B3E" />
            </g></svg>
      </button>
    </div>
    <!-- Stepper Navigation -->
    <div class="stepper-header">
      <div
        class="step"
        [class.active]="currentStep >= 0"
        [class.completed]="currentStep > 0"
      >
        <div class="step-circle">
          <span
            *ngIf="currentStep <= 0"
            class="step-number"
            [class.mobile-show-active]="currentStep === 0"
            >1</span
          >
          <span *ngIf="currentStep > 0" class="checkmark">✓</span>
        </div>
      </div>
      <span
        class="step-label-connector"
        [class.active]="currentStep >= 1"
        [class.mobile-show-active]="currentStep === 0"
      >
        {{ "TERMS_OF_SERVICE.STEPPER.LABELS.Terms of Service" | translate }}
      </span>

      <div
        class="step"
        [class.active]="currentStep >= 1"
        [class.completed]="currentStep > 1"
      >
        <div class="step-circle">
          <span
            *ngIf="currentStep <= 1"
            class="step-number"
            [class.mobile-show-active]="currentStep === 1"
            >2</span
          >
          <span *ngIf="currentStep > 1" class="checkmark">✓</span>
        </div>
      </div>
      <span
        class="step-label-connector"
        [class.active]="currentStep >= 2"
        [class.mobile-show-active]="currentStep === 1"
      >
        {{ "TERMS_OF_SERVICE.STEPPER.LABELS.Privacy Policy" | translate }}
      </span>

      <div
        class="step"
        [class.active]="currentStep >= 2"
        [class.completed]="currentStep > 2"
      >
        <div class="step-circle">
          <span
            *ngIf="currentStep <= 2"
            class="step-number"
            [class.mobile-show-active]="currentStep === 2"
            >3</span
          >
          <span *ngIf="currentStep > 2" class="checkmark">✓</span>
        </div>
      </div>
      <span
        class="step-label-connector"
        [class.mobile-show-active]="currentStep === 2"
      >
        {{ "TERMS_OF_SERVICE.STEPPER.LABELS.Terms of Use" | translate }}
      </span>
    </div>

    <!-- Step Content -->
    <div class="step-content">
      <!-- Step 1: Introduction -->
      <div *ngIf="currentStep === 0" class="step-panel step-1">
        <h3 class="step-title">
          {{ "TERMS_OF_SERVICE.STEP_1.TITLE" | translate }}
        </h3>

        <h4 class="section-title">
          {{ "TERMS_OF_SERVICE.STEP_1.SECTION_TITLE" | translate }}
        </h4>

        <div class="content-list">
          <div class="content-item">
            <span class="item-number">1.</span>
            <span class="item-text">{{
              "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_1" | translate
            }}</span>
          </div>

          <div class="content-item">
            <span class="item-number">2.</span>
            <div class="item-text">
              <p>
                {{ "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_2.MAIN" | translate }}
              </p>
              <p>
                {{ "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_2.SUB_1" | translate }}
              </p>
              <p>
                {{ "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_2.SUB_2" | translate }}
              </p>
            </div>
          </div>

          <div class="content-item">
            <span class="item-number">3.</span>
            <span class="item-text">{{
              "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_3" | translate
            }}</span>
          </div>

          <div class="content-item">
            <span class="item-number">4.</span>
            <span class="item-text">
              {{ "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_4" | translate }}
            </span>
          </div>
          <div class="content-item">
            <span class="item-number">5.</span>
            <span class="item-text">
              {{ "TERMS_OF_SERVICE.STEP_1.CONTENT.ITEM_5" | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- Step 2: Privacy Policy -->
      <div *ngIf="currentStep === 1" class="step-panel step-2">
        <h3 class="step-title">
          {{ "TERMS_OF_SERVICE.STEP_2.TITLE" | translate }}
        </h3>

        <h4 class="section-title">
          {{ "TERMS_OF_SERVICE.STEP_2.SECTION_TITLE" | translate }}
        </h4>

        <div class="content-list">
          <!-- Section 1: Personal Information Usage -->
          <div class="content-item">
            <span class="item-number">1.</span>
            <div class="item-text">
              <h5 class="subsection-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.TITLE" | translate }}</h5>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_1" | translate }}</p>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_2" | translate }}</p>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_3" | translate }}</p>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_4" | translate }}</p>
              
              <ul class="purpose-list">
                <li *ngFor="let item of step2ListItems">{{ item }}</li>
              </ul>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_5" | translate }}</p>
              
              <ul class="purpose-list">
                <li>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.PARA_6" | translate }}</li>
              </ul>
              
              <p class="footnote">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_1.FOOTNOTE_1" | translate }}</p>
            </div>
          </div>

          <!-- Section 2: Third Party Information -->
          <div class="content-item">
            <span class="item-number">2.</span>
            <div class="item-text">
              <h5 class="subsection-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.TITLE" | translate }}</h5>
              
              <div class="subsection">
                <h6 class="sub-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.SUB_TITLE_1" | translate }}</h6>
                <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.PARA_1" | translate }}</p>
              </div>
              
              <div class="subsection">
                <h6 class="sub-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.SUB_TITLE_2" | translate }}</h6>
                <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.PARA_2" | translate }}</p>
              </div>
              
              <p class="footnote">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_2.FOOTNOTE_1" | translate }}</p>
            </div>
          </div>

          <!-- Section 3: Joint Usage -->
          <div class="content-item">
            <span class="item-number">3.</span>
            <div class="item-text">
              <h5 class="subsection-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.TITLE" | translate }}</h5>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.PARA_1" | translate }}</p>
              
              <div class="subsection">
                <h6 class="sub-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.SUB_TITLE_1" | translate }}</h6>
                <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.PARA_2" | translate }}</p>
              </div>
              
              <div class="subsection">
                <h6 class="sub-title">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.SUB_TITLE_2" | translate }}</h6>
                <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.PARA_3" | translate }}</p>
              </div>
              
              <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.PARA_4" | translate }}</p>
              
              <p class="footnote">{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_3.FOOTNOTE_1" | translate }}</p>

              <!-- Cookie/Web Beacon Notice (subsection of Item 3) -->
              <div class="subsection">
                <h6 class="sub-title">※ {{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_4.TITLE" | translate }}</h6>
                <p>{{ "TERMS_OF_SERVICE.STEP_2.CONTENT.ITEM_4.PARA_1" | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3: Agreement -->
      <div *ngIf="currentStep === 2" class="step-panel">
        <h3 class="step-title">
          {{ "TERMS_OF_SERVICE.STEP_3.TITLE" | translate }}
        </h3>

        <div class="content-list">
          <div
            *ngFor="let condition of step3Conditions; let i = index"
            class="condition-item">
            <div class="checkbox-item">
              <span class="checkbox-icon">✓</span>
              <div class="condition-text">
                <span class="condition-main">{{ condition.MAIN }}</span>
                <div class="condition-note" *ngIf="condition.NOTES?.length > 0">
                  <div class="note-item" *ngFor="let note of condition.NOTES">
                    <span class="note-symbol">&#8251;</span>
                    <span class="note-content">{{ note }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="footer-wrapper">
      <p class="footer-text">{{ "TERMS_OF_SERVICE.FOOTER.SCROLL_MESSAGE" | translate }}</p>
      <div class="button-group">
        <app-button *ngIf="currentStep === 0" variant="secondary" (buttonClick)="onCancel()">
          {{ "TERMS_OF_SERVICE.BUTTONS.CLOSE" | translate }}
        </app-button>
        <app-button *ngIf="currentStep > 0" variant="secondary" (buttonClick)="previousStep()">
          {{ "TERMS_OF_SERVICE.BUTTONS.RETURN" | translate }}
        </app-button>
        <app-button *ngIf="currentStep < 2" variant="primary" (buttonClick)="nextStep()" [disabled]="!isScrolledToEnd" class="nav-btn">
          {{ "TERMS_OF_SERVICE.BUTTONS.AGREE_AND_CONTINUE" | translate }}
        </app-button>
        <app-button *ngIf="currentStep === 2" variant="primary" (buttonClick)="onAccept()" [disabled]="!isScrolledToEnd" class="nav-btn">
          {{ "TERMS_OF_SERVICE.BUTTONS.I have checked everything" | translate }}
        </app-button>
      </div>
    </div>
  </mat-dialog-actions>
  <!-- <div class="terms-footer-wrapper">
    <div class="footer-content">
      <p class="footer-text">
        {{ "TERMS_OF_SERVICE.FOOTER.SCROLL_MESSAGE" | translate }}
      </p>

      <div class="button-group">
        <app-button
          *ngIf="currentStep === 0"
          variant="secondary"
          (buttonClick)="onCancel()"
        >
          {{ "TERMS_OF_SERVICE.BUTTONS.CLOSE" | translate }}
        </app-button>

        <app-button
          *ngIf="currentStep > 0"
          variant="secondary"
          (buttonClick)="previousStep()"
          class="return-btn"
        >
          {{ "TERMS_OF_SERVICE.BUTTONS.RETURN" | translate }}
        </app-button>

        <app-button
          *ngIf="currentStep < 2"
          variant="primary"
          (buttonClick)="nextStep()"
          [disabled]="!isScrolledToEnd"
          class="nav-btn"
        >
          {{ "TERMS_OF_SERVICE.BUTTONS.AGREE_AND_CONTINUE" | translate }}
        </app-button>

        <app-button
          *ngIf="currentStep === 2"
          variant="primary"
          (buttonClick)="onAccept()"
          [disabled]="!isScrolledToEnd"
          class="nav-btn"
        >
          {{ "TERMS_OF_SERVICE.BUTTONS.I have checked everything" | translate }}
        </app-button>
      </div>
    </div>
  </div> -->
</div>
